import Vue from 'vue'
import App from './App.vue'

window._ = require('lodash');
window.cloneDeep = require('lodash.clonedeep');

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app')

